const getters = {
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  phone: state => state.user.phone,
  email: state => state.user.email,
  weixinId: state => state.user.weixinId,
  weixinPhoto: state => state.user.weixinPhoto,
  userRole: state => state.user.userRole,
  authStatus: state => state.user.authStatus,
  status: state => state.user.status,
  loginToken: state => state.user.loginToken,
  redirectUrl: state => state.user.redirectUrl,
  theatreName: state => state.user.theatreName,
  theatreCode: state => state.user.theatreCode,
  theatreAddress: state => state.user.theatreAddress,
  repairList: state => state.repair.repairList,
  serviceList: state => state.service.serviceList
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js